import React, { memo } from 'react'

import { graphql } from 'gatsby'

import Img from '../../../components/Img'

const Image = ({ slice }) => (
  <Img
    image={slice.primary?.image?.gatsbyImageData}
    alt={slice.primary?.image?.alt}
    className="brand-image"
  />
)

export default memo(Image)

export const query = graphql`
  fragment StoryPageDataBody1Image on PrismicStoryPageDataBody1Image {
    id
    primary {
      image {
        gatsbyImageData
        alt
      }
    }
  }
  fragment ArticlePageDataBodyImage on PrismicArticlePageDataBodyImage {
    id
    primary {
      image {
        gatsbyImageData
        alt
      }
    }
  }
`
